export default __webpack_public_path__ + "img/quantity-less.a9baf24.svg";